import axios from 'axios';
export const COPY_ITEM = 'COPY_ITEM';

export function copyItem(itemData) {
  return {
    type: COPY_ITEM,
    payload: axios.post('/api/copies/items.json?', itemData).then(({ data }) => {
      return data;
    }),
  };
}



